<template>
  <div class="container-cidades">
    <br>
    <div class="row">
       <h4 class="col-sm-12">Anúncio</h4>
  </div><!-- row -->

<form class="row" method="POST" ref="formulario" @submit.prevent.stop="add">
    <div class="form-group col-sm-3">
        <label>Anunciar na Chaves na mão:</label>
        <select class="form-control" name="anuncio" v-model="anunciado">
        <option value="Sim">Sim</option>
        <option value="Não">Não</option>
    </select>
  </div>


          <div class="form-group col-sm-12">
          <label>Titulo:</label>
          <input type="text" name="titulo" class="form-control"  v-model="titulo" />
        </div>
      

       
        <div class="form-group col-sm-12">
          <label>Observações:</label>
          <textarea  name="anuncio" class="form-control" v-model="anuncio" rows="10"></textarea>
        </div>

        

          <button  type="submit" class="btn btn-warning col-sm-2" style="max-height:40px;margin-top:30px;">+ATUALIZAR</button>


          

        <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
</form>
   
<br><br>
   


    <div class="row">

      <div v-if="showStatus" class="alert alert-info col-sm-12" role="alert">
       Informações atualizadas com sucesso!
       </div>
    


    </div><!-- row cards -->



  </div>
</template>

<script>
import axios from 'axios'


export default {
  name: 'Anuncio',
  components: {},
  props:['imovel'],
  data(){
      return {
          titulo:'',
         anuncio:'',
         anunciado:''
      }
  },
 

methods:{
    add(){
          this.loading = true;
          let fm = new FormData(this.$refs["formulario"]);
          fm.append('id',this.imovel);
          fm.append('titulo',this.titulo);
          fm.append('anuncio',this.anuncio);
          fm.append('anunciado',this.anunciado);
        

          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/updateAnuncio',fm)
          .then(() => {this.get();this.showStatus = true;})
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
      },

   
    get(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getAnuncio',{imovel:this.imovel})
          .then(response =>{this.updateInfo(response.data);this.loading = false;})
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },
    
    updateInfo(data){
      this.titulo = data.IM_TITULO_ANUNCIO;
      this.anuncio = data.IM_TEXTO_ANUNCIO;
      this.anunciado = data.IM_ANUNCIADO;
     
    }

  

},
  
  mounted () {
  this.get();
  }



}
</script>